var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "kid_star"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_713_13362",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_713_13362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kid_star_2",
    d: "M5.08276 4.26732L6.94943 1.85065C7.08276 1.67287 7.2411 1.54232 7.42443 1.45898C7.60776 1.37565 7.79943 1.33398 7.99943 1.33398C8.19943 1.33398 8.3911 1.37565 8.57443 1.45898C8.75776 1.54232 8.9161 1.67287 9.04943 1.85065L10.9161 4.26732L13.7494 5.21732C14.0383 5.30621 14.2661 5.4701 14.4328 5.70898C14.5994 5.94787 14.6828 6.21176 14.6828 6.50065C14.6828 6.63398 14.6633 6.76732 14.6244 6.90065C14.5855 7.03398 14.5217 7.16176 14.4328 7.28398L12.5994 9.88398L12.6661 12.6173C12.6772 13.0062 12.5494 13.334 12.2828 13.6006C12.0161 13.8673 11.705 14.0007 11.3494 14.0007C11.3272 14.0007 11.205 13.984 10.9828 13.9507L7.99943 13.1173L5.0161 13.9507C4.96054 13.9729 4.89943 13.9868 4.83276 13.9923C4.7661 13.9979 4.70499 14.0007 4.64943 14.0007C4.29387 14.0007 3.98276 13.8673 3.7161 13.6006C3.44943 13.334 3.32165 13.0062 3.33276 12.6173L3.39943 9.86732L1.58276 7.28398C1.49387 7.16176 1.42999 7.03398 1.3911 6.90065C1.35221 6.76732 1.33276 6.63398 1.33276 6.50065C1.33276 6.22287 1.41332 5.96454 1.57443 5.72565C1.73554 5.48676 1.96054 5.31732 2.24943 5.21732L5.08276 4.26732Z",
    fill: "#FFD647"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.7e5264b353acd5ec0a49deec9193f9aa.svg";
export { ForwardRef as ReactComponent };